import React, { FC } from 'react'
import { BackgroundNotificationItem } from './BackgroundNotificationItem'
import type { BackgroundActivityNotification } from '../types/BackgroundActivityTypes'

interface Props {
  notifications: Array<BackgroundActivityNotification>
}

const BackgroundNotifications: FC<Props> = (props): any => {
  const { notifications } = props

  return notifications.map((notification) => {
    return (
      <BackgroundNotificationItem
        key={`${notification.id}${notification.status}`}
        notification={notification}
      />
    )
  })
}
export default BackgroundNotifications
